import { render, staticRenderFns } from "./DeliveryFeesRadiusForm.vue?vue&type=template&id=16782f76"
import script from "./DeliveryFeesRadiusForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryFeesRadiusForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports